export default function ({ ...props }) {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M43.4803 25.789C43.4803 35.6136 35.5378 43.5779 25.7401 43.5779C15.9425 43.5779 8 35.6136 8 25.789C8 15.9644 15.9425 8 25.7401 8C35.5378 8 43.4803 15.9644 43.4803 25.789Z"
                fill="#FDF6E8"
                stroke="url(#paint0_linear_289_16097)"
                strokeWidth="2"
            />
            <path
                d="M14.7578 21.5527H23.6807M14.7578 31.3765H23.6807M27.7989 21.5527H36.7218M14.7578 26.5974H23.6807M27.7989 31.7179V27.2645C27.7989 26.8961 28.1062 26.5974 28.4853 26.5974H36.7218"
                stroke="#E7BD7C"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M30.8086 38.5404V37.2243C30.8086 36.9904 30.9982 36.8008 31.2321 36.8008H42.4801C43.0324 36.8008 43.4801 37.2485 43.4801 37.8008V38.5618C43.4801 39.0204 43.1682 39.4203 42.7233 39.5318L40.2208 40.1591C40.1413 40.1791 40.0596 40.1892 39.9776 40.1892H34.7201C34.647 40.1892 34.574 40.1811 34.5026 40.1652L31.5911 39.5164C31.1338 39.4145 30.8086 39.0089 30.8086 38.5404Z"
                fill="#FDF6E8"
            />
            <path
                d="M30.8086 41.929V40.613C30.8086 40.3791 30.9982 40.1895 31.2321 40.1895H42.4801C43.0324 40.1895 43.4801 40.6372 43.4801 41.1895V41.9505C43.4801 42.4091 43.1682 42.8089 42.7233 42.9205L40.2208 43.5478C40.1413 43.5677 40.0596 43.5778 39.9776 43.5778H34.7201C34.647 43.5778 34.574 43.5698 34.5026 43.5539L31.5911 42.9051C31.1338 42.8032 30.8086 42.3975 30.8086 41.929Z"
                fill="#FDF6E8"
            />
            <path
                d="M36.9828 37.3828C40.8588 37.3828 44.0009 36.494 44.0009 35.3975C44.0009 34.301 40.8588 33.4121 36.9828 33.4121C33.1069 33.4121 29.9648 34.301 29.9648 35.3975C29.9648 36.494 33.1069 37.3828 36.9828 37.3828Z"
                fill="#FDF6E8"
                stroke="#D2A160"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.9648 38.7051C29.9648 39.8016 33.1069 40.6904 36.9828 40.6904C40.8588 40.6904 44.0009 39.8016 44.0009 38.7051"
                stroke="#D2A160"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.9648 42.0156C29.9648 43.1121 33.1069 44.001 36.9828 44.001C40.8588 44.001 44.0009 43.1121 44.0009 42.0156"
                stroke="#D2A160"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M29.9648 35.3965V42.0144" stroke="#D2A160" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M44.001 35.3965V42.0144" stroke="#D2A160" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_289_16097" x1="25.7401" y1="8" x2="25.7401" y2="43.5779" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCDA98" />
                    <stop offset="1" stopColor="#CF9D5B" />
                </linearGradient>
            </defs>
        </svg>
    );
}
